"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.buildTransactionWithAPI = void 0;
var web3_1 = require("./api/chain/web3");
var utils_1 = require("./utils");
var web3_js_1 = require("@solana/web3.js");
var buildTransactionWithAPI = function (account, transaction, api) { return __awaiter(void 0, void 0, void 0, function () {
    var instructions, recentBlockhash, feePayer, tx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                instructions = buildInstructions(transaction);
                return [4 /*yield*/, api.getRecentBlockhash()];
            case 1:
                recentBlockhash = _a.sent();
                feePayer = new web3_js_1.PublicKey(account.freshAddress);
                tx = new web3_js_1.Transaction({
                    feePayer: feePayer,
                    recentBlockhash: recentBlockhash
                });
                tx.add.apply(tx, __spreadArray([], __read(instructions), false));
                return [2 /*return*/, [
                        tx.compileMessage().serialize(),
                        function (signature) {
                            return (0, web3_1.addSignatureToTransaction)({
                                tx: tx,
                                address: account.freshAddress,
                                signature: signature
                            }).serialize();
                        },
                    ]];
        }
    });
}); };
exports.buildTransactionWithAPI = buildTransactionWithAPI;
function buildInstructions(tx) {
    var commandDescriptor = tx.model.commandDescriptor;
    if (commandDescriptor === undefined) {
        throw new Error("missing command descriptor");
    }
    if (Object.keys(commandDescriptor.errors).length > 0) {
        throw new Error("can not build invalid command");
    }
    return buildInstructionsForCommand(commandDescriptor.command);
}
function buildInstructionsForCommand(command) {
    switch (command.kind) {
        case "transfer":
            return (0, web3_1.buildTransferInstructions)(command);
        case "token.transfer":
            return (0, web3_1.buildTokenTransferInstructions)(command);
        case "token.createATA":
            return (0, web3_1.buildCreateAssociatedTokenAccountInstruction)(command);
        case "stake.createAccount":
            return (0, web3_1.buildStakeCreateAccountInstructions)(command);
        case "stake.delegate":
            return (0, web3_1.buildStakeDelegateInstructions)(command);
        case "stake.undelegate":
            return (0, web3_1.buildStakeUndelegateInstructions)(command);
        case "stake.withdraw":
            return (0, web3_1.buildStakeWithdrawInstructions)(command);
        case "stake.split":
            return (0, web3_1.buildStakeSplitInstructions)(command);
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
//# sourceMappingURL=js-buildTransaction.js.map